<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>系统角色</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="insert">新增</el-button>
        <el-input size="small" placeholder="描述" v-model="condition.desc"></el-input>
        <el-input size="small" placeholder="名称" v-model="condition.name"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-table :data="systemRoles" border stripe style="width: 100%" size="mini">
        <el-table-column prop="desc" label="描述" width="300" sortable>
          <template slot-scope="scope">
            <span :style="{'color':scope.row.color}">{{ scope.row.desc }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="300" sortable></el-table-column>
        <el-table-column prop="displayOrder" label="排序" width="100"></el-table-column>
        <el-table-column prop="color" label="颜色" width="100" sortable></el-table-column>
        <el-table-column prop="note" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemRole" :rules="rules" label-width="60px" size="small">
        <el-form-item label="描述" prop="desc">
          <el-input v-model="systemRole.desc"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="systemRole.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input v-model="systemRole.displayOrder"></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="color">
          <el-input v-model="systemRole.color"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="systemRole.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemRoleIndex',
  data () {
    return {
      // 系统角色列表
      systemRoles: [],
      // 遮罩
      loading: {main: false, editDialog: false},
      // 可见
      visible: {editDialog: false},
      // 条件
      condition:{},
      // 系统角色
      systemRole: {},
      // 校验规则
      rules: {
        desc: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        name: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let vm = this;
              vm.$http.get('rest/sys/systemRole/uniqueCheck', {params: {name: value, id: (this.systemRole.id || '')}}).then(response => {
                if (response.body) {
                  callback(new Error('该项已存在'));
                } else {
                  callback();
                }
              }, response => {
                vm.$baize.handle(vm, response);
              })
            }
          }
        ],
        color: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

    vm.findByCondition();
  },
  
  methods: {
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemRole/findByCondition', {params: params}).then(response => {
        vm.systemRoles = response.body.systemRoles;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.systemRole = {}
    },
    
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemRole = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.desc+'_'+record.name + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemRole/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemRole/saveData', vm.systemRole).then(function (response) {
          vm.systemRole = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false;
          vm.findByCondition(vm.paging.currPage);
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemrole/SystemRoleIndex.vue